import { EventDispatcher } from './event/index'
import { Integration } from './integration/integration'
import { SystemEnvironment } from './integration'
import { Translation } from './translation/index'

export class Inject {
  public readonly translation = new Translation()
  public readonly event = new EventDispatcher()
  public readonly integration: Integration
  
  constructor(private env: SystemEnvironment) {
    this.integration = new Integration(this.env)
  }
}

export function defineAylaComponents (env: SystemEnvironment): void {
  (window as any).aylacc = new Inject(env);
  
  ((window as any).aylacc as Inject).integration.loader()
}

export function useCore (): Inject {
  return (window as any).aylacc
}
